import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import { ToastContainer } from 'react-toastify'
import { ErrorBoundary } from '@appsignal/react'

import Loader from 'components/Loader'
import OAuthIframe from 'components/OAuth/OAuthIframe'

import AppRoutes from 'views/AppRoutes'
import { store } from 'store'
const persistor = persistStore(store)
import { appsignal } from 'resources/appsignal'

function App() {
  return (
    <ErrorBoundary instance={appsignal}>
      <OAuthIframe />
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <AppRoutes />
          <ToastContainer />
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  )
}

export default App
